import * as angular from "angular";

import { HIERARCHY_SERVICE, HierarchyService } from "../hierarchy-service/hierarchy.service";
import { HIERARCHY_SIDENAV_COMPONENT, hierarchySidenavComponent } from "./hierachySidenav.component";

export default angular
    .module("board.web.admin.hierarchySidenav", [])
    .component(HIERARCHY_SIDENAV_COMPONENT, hierarchySidenavComponent)
    .service(HIERARCHY_SERVICE, HierarchyService)
    .name;


// WEBPACK FOOTER //
// ./app/hierarchy-nav/hierarchySideNav.module.ts